import {
  BaseQueryApi,
  FetchArgs,
  createApi,
  fetchBaseQuery,
} from "@reduxjs/toolkit/query/react";
import { getAbsoluteUrl, getLocale } from "../services/utils";
import { API_VERSION } from "../constants/values";
import { showLoading, hideLoading } from "react-redux-loading-bar";

const customBaseQuery = async (args: string | FetchArgs, api: BaseQueryApi) => {
  let url = typeof args === "string" ? args : args.url;
  let method = typeof args === "string" ? "GET" : args.method ?? "GET";
  let params = typeof args === "string" ? {} : args.params ?? {};
  let body = typeof args === "string" ? {} : args.body ?? {};
  let headers = typeof args === "string" ? {} : args.headers ?? {};

  let common = {
    api_version: API_VERSION,
    version: process.env.RELEASE_VERSION,
    lang: getLocale(),
  };

  if (method === "GET") {
    params = { ...params, ...common };
    body = undefined;
  } else {
    body = { ...body, ...common };
  }
  api.dispatch(showLoading());

  try {
    const resp = await fetchBaseQuery({ baseUrl: getAbsoluteUrl("/") })(
      { url, method, params, body, headers },
      api,
      {},
    );

    if (
      resp.error &&
      (typeof resp.error.status === "string" || resp.error.status >= 500)
    ) {
      return {
        ...resp,
        error: {
          status: 500,
          data: {},
        },
      };
    }

    return resp;
  } finally {
    api.dispatch(hideLoading());
  }
};

export const rtkApi = createApi({
  reducerPath: "rtkApi",
  baseQuery: customBaseQuery,
  endpoints: () => ({}),
  tagTypes: ["Clients", "Groups", "AICredits", "Referrals", "Trainers"]
});

export default rtkApi;
